import { render, staticRenderFns } from "./i-currency.vue?vue&type=template&id=98f9a200&scoped=true&"
import script from "./i-currency.vue?vue&type=script&lang=js&"
export * from "./i-currency.vue?vue&type=script&lang=js&"
import style0 from "./i-currency.vue?vue&type=style&index=0&id=98f9a200&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f9a200",
  null
  
)

export default component.exports